export default __webpack_public_path__ + "static/media/bell.341e1ccd.mp3";